import { render, staticRenderFns } from "./BucketForm.vue?vue&type=template&id=7722c80d&"
import script from "./BucketForm.vue?vue&type=script&lang=js&"
export * from "./BucketForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports